import { validateEmailFormat } from 'hb-react/shared/utils/validators/emailFormat';
import { validateMaxLength } from 'hb-react/shared/utils/validators/maxLength';
import { validateRequired } from 'hb-react/shared/utils/validators/required';

export const validateEmail = ({ maxLength, required, value }) => {
  let error;

  if (required) {
    error = validateRequired(value);
  }

  if (!error) {
    error = validateEmailFormat(value);
  }

  if (maxLength && !error) {
    error = validateMaxLength(value, maxLength);
  }

  return error;
};
